import { ChangeDetectionStrategy, Component, Directive, Input } from '@angular/core';

@Directive({
  selector: '[tiimeOverlayHeader]',
  exportAs: 'tiime-overlay-header',
  host: {
    class: 'tiime-overlay-header'
  }
})
export class TiimeOverlayHearderDirective {}

@Directive({
  selector: '[tiimeOverlayContent]',
  exportAs: 'tiime-overlay-content',
  host: {
    class: 'tiime-overlay-content'
  }
})
export class TiimeOverlayContentDirective {}

@Directive({
  selector: '[tiimeOverlayFooter]',
  exportAs: 'tiime-overlay-footer',
  host: {
    class: 'tiime-overlay-footer'
  }
})
export class TiimeOverlayFooterDirective {}

@Component({
  selector: 'tiime-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TiimeOverlayComponent {
  @Input() isLoading = false;
}
